// extracted by mini-css-extract-plugin
export default {"header":"OLPddS","makeItDisplayAnimation":"Gx8E5k","headerTitle":"AeozBb","headerTitleCartV2":"eIqx3J","headerSubtitle":"ZdZcTU","headerSubtitleGray":"moGoCh"};